module.exports = __webpack_public_path__ + "static/media/route-solid.8dee6c08.svg";